export default "__VITE_ASSET__DRng6LR2__"